(self.webpackChunkjuno_shopify_template = self.webpackChunkjuno_shopify_template || []).push([
    [6956], {
        6956: function(t, e, r) {
            r.r(e), r.d(e, {
                ProductForm: function() {
                    return s
                }
            });
            var i = r(4412),
                o = r(6993);
            class s extends HTMLFormElement {
                constructor() {
                    super(), this.cartDrawer = void 0, this.variantIdInput = void 0, this.submitButton = void 0, this.abortController = new AbortController, this.isProductCard = this.closest(".js-product-card"), this.toggleButtonLoading = () => {
                        for (const t of this.submitButton.children) t.classList.toggle("invisible")
                    }, this.addEventListener("submit", this.onSubmitHandler.bind(this)), this.variantIdInput = (0, i.U2)('[name="id"]', this), this.variantIdInput.disabled = !1, this.submitButton = (0, i.U2)('[type="submit"]', this), this.cartDrawer = (0, i.U2)(".js-drawer-cart"), (0, o.RB)(this.closest(".shopify-section")), this.cartDrawer && this.submitButton.setAttribute("aria-haspopup", "dialog")
                }
                onSubmitHandler(t) {
                    if (t.preventDefault(), "true" === this.submitButton.getAttribute("aria-disabled")) return;
                    this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", "true"), this.toggleButtonLoading();
                    const e = new FormData(this);
                    this.cartDrawer && (e.append("sections", Array.from(new Set(DrawerCart.getSectionsToRender().map((t => t.section)))).join(",")), e.append("sections_url", window.location.pathname)), e.get("quantity") || e.set("quantity", "1");
                    const r = (0, i.U2)(".js-quantity", this);
                    r && e.set("quantity", r.value), this.abortController.abort(), this.abortController = new AbortController;
                    const s = (0, i.U2)(".js-personalisation-field");
                    s && e.set(s.name, s.value);
                    let a = Shopify.routes.cartAddUrl;
                    const n = (0, i.U2)(`.js-drawer-cart-item[data-product-id="${e.get("product-id")}"][data-variant-id="${e.get("id")}"]`);
                    // n && (e.set("quantity", +n.getAttribute("data-qty") + +e.get("quantity")), a = Shopify.routes.cartChangeUrl), fetch(a, {
                    fetch(a, {
                        method: "POST",
                        headers: {
                            "X-Requested-With": "XMLHttpRequest",
                            Accept: "application/javascript"
                        },
                        body: e,
                        signal: this.abortController.signal
                    }).then((t => t.json())).then((t => {
                        if (t.status) {
                            const e = document.querySelector("upsell-discount");
                            e && e.dispatchEvent(new CustomEvent("UpsellButton:ReInit")), this.handleErrorMessage(t.description);
                            const r = this.submitButton.querySelector(".sold-out-message");
                            if (!r) return;
                            this.submitButton.setAttribute("aria-disabled", "true");
                            return (0, i.U2)("span", this.submitButton).classList.add("hidden"), r.classList.remove("hidden"), void(this.error = !0)
                        }
                        this.cartDrawer ? (this.error = !1, DrawerCart.renderContents(t)) : window.location.href = Shopify.routes.cartUrl
                    })).catch((t => {
                        console.error(t)
                    })).finally((() => {
                        this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"), this.error || this.submitButton.removeAttribute("aria-disabled"), this.toggleButtonLoading();
                        const t = this.closest(".shopify-section"),
                            e = (0, i.U2)(".js-quantity-input", t);
                        e && (e.value = 1), (0, o.RB)(t, !0, "1"), this.isProductCard && this.renderProductCard()
                    }))
                }
                renderProductCard() {
                    const t = this.isProductCard?.querySelector("variant-options");
                    t && t.renderProductCardInfo()
                }
                handleErrorMessage(t = !1) {
                    if (this.errorMessageWrapper = this.errorMessageWrapper || document.querySelector(".js-product-form-error"), this.errorMessageWrapper && (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".js-product-form-error-message"), this.errorMessageWrapper.toggleAttribute("hidden", !t), t))
                        if ("object" === typeof t && t.email) this.errorMessage.textContent = t.email;
                        else if (-1 !== t.indexOf("can't add more")) {
                        const t = (0, o.tW)(this.closest(".shopify-section"));
                        t && (this.errorMessage.textContent = `You can only add ${t?.totalStock} items ${t.variantTitle} to the cart`)
                    } else this.errorMessage.textContent = JSON.stringify(t)
                }
            }
            customElements.define("product-form", s, {
                extends: "form"
            })
        },
        6993: function(t, e, r) {
            r.d(e, {
                RB: function() {
                    return s
                },
                a3: function() {
                    return a
                },
                tW: function() {
                    return o
                }
            });
            var i = r(4412);

            function o(t) {
                let e = (0, i.U2)(".js-variant-quantity:checked", t);
                if (!e && (e = (0, i.U2)(".js-variant-quantity[checked]", t), !e)) return null;
                let r = parseInt(e?.getAttribute("data-onhandstock") ?? "0"),
                    o = parseInt(e?.getAttribute("data-futurestock") ?? "null"),
                    s = e?.getAttribute("data-inventory-policy") ?? "";
                e || (r = Shopify.product_has_only_default_variant.inventory.onHandStock, o = Shopify.product_has_only_default_variant.inventory.futureStock, s = Shopify.product_has_only_default_variant.inventory.policy);
                const a = e?.getAttribute("data-product-id"),
                    n = e?.getAttribute("data-variant-id"),
                    d = e?.getAttribute("data-delivery-date"),
                    u = (0, i.U2)(`.js-drawer-cart-item[data-product-id="${a}"][data-variant-id="${n}"]`);
                let c = r,
                    l = o,
                    h = 0;
                if (u) {
                    const t = Number(u.getAttribute("data-qty"));
                    c = Math.max(0, r - t), h = Math.max(0, t - (r - c)), l = Math.max(0, l - h)
                }
                const v = r + o;
                return {
                    productId: a,
                    variantId: n,
                    productName: e?.getAttribute("data-product-title"),
                    variantTitle: e?.getAttribute("data-variant-title"),
                    continuousStockTag: e?.getAttribute("data-continuous-tag"),
                    futureStockTag: e?.getAttribute("data-futurestock-tag"),
                    onHandStock: r,
                    futureStock: o,
                    inventoryPolicy: s,
                    totalStock: v,
                    liveOnhandStock: c,
                    liveFutureStock: l,
                    variantDeliveryDate: d
                }
            }

            function s(t, e = !1, r = "0") {
                if (!t?.classList.contains("shopify-section--main-product")) return;
                const s = (0, i.U2)('[is="product-form"]', t);
                if (!s) return;
                if (!s.querySelector('[name="add"]')) return;
                const a = o(t);
                if (!a) return;
                let n = "add-to-cart";
                e ? n = parseInt(r, 10) > a.liveOnhandStock && a.liveFutureStock > 0 || parseInt(r, 10) > a.liveOnhandStock && "continue" === a.inventoryPolicy ? "pre-order" : "add-to-cart" : ((0 === a.liveOnhandStock && a.liveFutureStock > 0 || "continue" === a.inventoryPolicy && 0 === a.liveOnhandStock) && (n = "pre-order"), a.liveOnhandStock > 0 && a.futureStock > 0 && (n = "add-to-cart")), (a.liveFutureStock > 0 && 0 === a.liveOnhandStock || "continue" === a.inventoryPolicy && 0 === a.liveOnhandStock) && (n = "pre-order"), (0 === a.liveFutureStock && 0 === a.liveOnhandStock && "deny" === a.inventoryPolicy || "deny" === (Number.isNaN(a.liveFutureStock) && a.inventoryPolicy)) && (n = "sold-out"),
                    function(t = "add-to-cart", e, r) {
                        const o = (0, i.U2)('[is="product-form"]', r);
                        if (!o) return;
                        const s = o.querySelector('[name="add"]');
                        if (!s) return;
                        const a = s.querySelector(".js-button-add-text"),
                            n = (0, i.go)(".js-delivery-notice-text", r),
                            d = (0, i.U2)(".js-delivery-notice-sold-out", r),
                            u = (0, i.U2)(".js-delivery-earliestpost", r),
                            c = (0, i.U2)(".js-delivery-add-to-cart", r),
                            l = (0, i.U2)(".js-pre-order", r),
                            h = (0, i.U2)(".js-quantity-input", r),
                            v = s.querySelector(".sold-out-message");
                        if (n.forEach((r => {
                                if (r.classList.contains("hidden") || (r.classList.add("hidden"), r.classList.remove("block")), "pre-order" === t) {
                                    e.variantDeliveryDate && e.liveFutureStock > 0 && (u?.classList.add("block"), u?.classList.remove("hidden"));
                                    const t = e.liveFutureStock - (Number(h.value) - e.liveOnhandStock);
                                    "continue" === e.inventoryPolicy && (0 === e.liveFutureStock || t < 0) && (d?.classList.add("block"), d?.classList.remove("hidden"), u?.classList.remove("block"), u?.classList.add("hidden"))
                                }
                                "sold-out" === t && ("deny" === e.inventoryPolicy ? (d?.classList.remove("block"), d?.classList.add("hidden"), c?.classList.add("block"), c?.classList.remove("hidden")) : (d?.classList.add("block"), d?.classList.remove("hidden"))), "add-to-cart" === t && (c?.classList.add("block"), c?.classList.remove("hidden"))
                            })), v && v.classList.add("hidden"), s.setAttribute("aria-disabled", "true"), "add-to-cart" === t) s.setAttribute("aria-disabled", "false"), s.classList.remove("bg-yellow", "border-yellow"), a && (a.innerHTML = Shopify.theme.i18n.addToCart), l?.setAttribute("disabled", "disabled");
                        else if ("pre-order" === t) {
                            s.setAttribute("aria-disabled", "false"), s.classList.add("bg-yellow", "border-yellow"), a && (a.innerHTML = Shopify.theme.i18n.preOrder), l?.removeAttribute("disabled");
                            const t = e.liveFutureStock - (Number(h.value) - e.liveOnhandStock);
                            e.variantDeliveryDate && t >= 0 ? l.value = e.futureStockTag : l.value = e.continuousStockTag, console.log("live inv", e.liveFutureStock)
                        } else "sold-out" === t && (v && v.classList.remove("hidden"), s.setAttribute("aria-disabled", "true"), a && (a.innerHTML = Shopify.theme.i18n.soldOut), l?.setAttribute("disabled", "disabled"), h && h.setAttribute("max", "0"))
                    }(n, a, t)
            }

            function a(t, e = !1) {
                if (!t) return;
                const r = o(t);
                if (!r) return;
                const s = (0, i.U2)(".js-quantity-input", t);
                if (e && (s.value = 1), "deny" === r.inventoryPolicy && r.onHandStock > 0) {
                    let t = r.liveOnhandStock;
                    0 === t && r.liveFutureStock > 0 && (t = r.liveFutureStock), s.setAttribute("max", t)
                } else s?.removeAttribute("max")
            }
        }
    }
]);